module.exports = __webpack_public_path__ + "img/notebook.229fc124.png";